module.exports = __webpack_public_path__ + "79013430f49da229c7faa5dabb2e3fdf.MP3";